import { useEffect } from 'react';
import { monitoringService } from '../services/monitoringService';

export const useWorkflowJobsRealtime = (userId, onJobUpdate) => {
  useEffect(() => {
    if (!userId) return;

    const channel = monitoringService?.subscribeToWorkflowJobs(userId, onJobUpdate);

    return () => {
      if (channel) {
        monitoringService?.unsubscribeFromWorkflowJobs(channel);
      }
    };
  }, [userId, onJobUpdate]);
};

export default useWorkflowJobsRealtime;
